/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Audit_Mfa_Missing_AdminInputs */

const fr_account_audit_mfa_missing_admin = /** @type {(inputs: Account_Audit_Mfa_Missing_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Double authentification non activée (admin)`)
};

/**

* @param {Account_Audit_Mfa_Missing_AdminInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const account_audit_mfa_missing_admin = /** @type {((inputs?: Account_Audit_Mfa_Missing_AdminInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Audit_Mfa_Missing_AdminInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_account_audit_mfa_missing_admin(inputs)
});